import { ArticleTypeAttributeType } from 'src/erp-articles/article-types/article-type.model';
import { ArticleTypeAttribute } from './../../article-types/article-type.model';
import { Injectable } from "@angular/core";
import { NumberFormatService } from '@sdbn/appclient';

@Injectable({
  providedIn: 'root'
})
export class AttributeValueResolverService {

  private DECIMAL_SCALE = 3;

  constructor(private numberFormatService: NumberFormatService) { }

  public transform(value: string, articleTypeAttribute: ArticleTypeAttribute): string {
    if (value == null || value === 'null') {
      return '';
    }
    switch (articleTypeAttribute.type) {
      case ArticleTypeAttributeType.DATE:
        return value;
      case ArticleTypeAttributeType.DECIMAL:
        return this.formatDecimal(value);
      case ArticleTypeAttributeType.NUMBER:
        return this.formatNumber(value);
      case ArticleTypeAttributeType.LOOKUP:
        return this.getLookupValue(value, articleTypeAttribute);
      default: return value;
    }
  }

  private formatDecimal(value: string) {
    if (Number.isNaN(value)) {
      return '';
    }
    return this.numberFormatService.format(Number.parseFloat(value), this.DECIMAL_SCALE);
  }

  private formatNumber(value: string) {
    if (Number.isNaN(value)) {
      return '';
    }
    return this.numberFormatService.format(Number.parseFloat(value), 0);
  }

  private getLookupValue(value: string, articleTypeAttribute: ArticleTypeAttribute): string {
    const lookupValue = articleTypeAttribute.values.find(v => ('' + v.id) === value);
    return lookupValue == null ? '' : lookupValue.value;
  }

}
